import {useMemo, useState} from "react";
import {Stack, Typography} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import {appStyles} from "../../../../AppStyles.ts";
import {StyledInputBase, StyledSearch, StyledSearchIconWrapper} from "../../../AppStyledComponents.tsx";
import type {ContentMetadata} from "../../../../sdo/ContentMetadata.ts";
import ContentMetadataCard from "./metadata/ContentMetadataCard.tsx";

// TODO: Replace with API call to AResourceProfileManager.readContentMetadata()
function buildTestData(): ContentMetadata[] {
    return [
        {
            uid: "1",
            key: "Title",
            value: "Quarterly Threat Landscape Report – Q1 2026",
            groupKey: "Document",
            pointers: [],
        },
        {
            uid: "2",
            key: "Author",
            value: "J. Doe, Analyst",
            groupKey: "Document",
            pointers: [
                {uid: "p1", typeKey: "character", display: "Jane Doe"},
            ],
        },
        {
            uid: "3",
            key: "Created",
            value: "2026-01-12T09:14:22Z",
            groupKey: "Timestamps",
            pointers: [],
        },
        {
            uid: "4",
            key: "Keywords",
            value: "threat actor, phishing, credential theft, APT-41, supply chain",
            groupKey: "Classification",
            pointers: [
                {uid: "p2", typeKey: "character", display: "APT-41"},
                {uid: "p3", typeKey: "organization", display: "Vendor Alpha"},
            ],
        },
        {
            uid: "5",
            key: "SHA-256",
            value: "c1d2e3f4a5b6071829304a5b6c7d8e9f0a1b2c3d4e5f60718293a4b5c6d7e8f9",
            groupKey: "Hashes",
            pointers: [],
        },
        {
            uid: "6",
            key: "Source URL",
            value: "https://intel.partner.example/reports/tlp-amber/2026-q1",
            groupKey: "Provenance",
            pointers: [],
        },
    ];
}

function UXResourceMetadataPanel() {
    const [metadataList] = useState<ContentMetadata[]>(buildTestData);
    const [filterText, setFilterText] = useState("");

    const filtered = useMemo(() => {
        const q = filterText.trim().toLowerCase();
        if (!q) return metadataList;
        return metadataList.filter((m) => {
            return (m.key && m.key.toLowerCase().includes(q))
                || (m.value && m.value.toLowerCase().includes(q))
                || (m.groupKey && m.groupKey.toLowerCase().includes(q));
        });
    }, [metadataList, filterText]);

    return (
        <Stack sx={appStyles.defaultPanelContainer} direction="column" padding={1} width="100%">
            {/* Title */}
            <Stack direction="row" padding={1} justifyContent="center">
                <Typography sx={appStyles.panelSectionTitle}>Content Metadata</Typography>
            </Stack>

            {/* Filter bar */}
            <Stack direction="row" spacing={1} padding={1} alignItems="center" justifyContent="center" sx={{position: "relative"}}>
                <StyledSearch>
                    <StyledSearchIconWrapper>
                        <SearchIcon sx={{fontSize: 16, color: "#7093a0"}}/>
                    </StyledSearchIconWrapper>
                    <StyledInputBase
                        placeholder="Filter metadata..."
                        value={filterText}
                        onChange={(e) => setFilterText(e.target.value)}
                    />
                </StyledSearch>

                <Typography sx={appStyles.panelFilterCount}>
                    Showing {filtered.length} of {metadataList.length}
                </Typography>
            </Stack>

            {/* Metadata cards list */}
            <Stack direction="column" spacing={1} sx={{...appStyles.defaultPanelCardsWrapper, padding: "8px", alignItems: "stretch"}}>
                {filtered.map((m) => (
                    <ContentMetadataCard key={m.uid} metadata={m}/>
                ))}
                {filtered.length === 0 && (
                    <Typography sx={{
                        color: "rgba(242, 245, 250, 0.4)",
                        fontSize: "0.80rem",
                        textAlign: "center",
                        padding: "24px",
                    }}>
                        No metadata entries match the current filter.
                    </Typography>
                )}
            </Stack>
        </Stack>
    );
}

export default UXResourceMetadataPanel;
